import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { deleteUserAdmin, getUserAdmins } from "../../redux/services/userAdminSlice";

const UserAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state?.userAdmin?.userAdminData);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");

  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];

  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllUsers = useCallback(async () => {
    try {
      await dispatch(getUserAdmins({ page: page + 1, limit: pageLimit, searchData, user: "telecaller" }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllUsers();
  }, [getAllUsers]);

  const deleteUserData = async () => {
    try {
      const response = await dispatch(deleteUserAdmin(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllUsers();
    } catch (error) {}
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "firstName",
      key: "firstName",
      render: (firstName) => (firstName ? firstName : "-"),
    },
    {
      header: "lastName",
      key: "lastName",
      render: (lastName) => (lastName ? lastName : "-"),
    },
    { header: "Designation", key: "designation" },
    { header: "Email", key: "email" },
    { header: "contact", key: "contact", render: (contact) => (contact?.mobile ? contact?.mobile : "-") },
    { header: "Refer Code", key: "referralCode" },
    {
      width: 250,
      header: "Access",
      key: "access",
      render: (_, row) => (row?.access?.length ? row?.access.join(", ").toUpperCase() : "-"),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.USER_ADMIN.ADD_EDIT}?userId=${row._id}`, {
          state: { row },
        });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table title="User Admin" buttonTitle="Add User" showSearchbar={true} searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchData={setSearchData} onAddClick={() => navigate(ROUTES.USER_ADMIN.ADD_EDIT)} columns={columns} data={userData?.subject_data || []} actions={actions} pageCount={userData?.state?.page_limit} onPageChange={(selectedItem) => setPage(selectedItem.selected)} pageLimitOptions={limitOptions} selectedPageLimit={pageLimit} onPageLimitChange={setPageLimit} />

      {confirm && <ConfirmationPage topicName="User" confirm={confirm} onDelete={deleteUserData} onCancel={() => setConfirm(false)} />}
    </>
  );
};

export default UserAdmin;
